import { Component, ElementRef, NgZone, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LoadingBarService } from '@ngx-loading-bar/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { ViasConnectionService } from '../services/vias-connection.service';

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: 'vias-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  private _router: Subscription;
  public mediaMatcher: MediaQueryList = matchMedia(
    `(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`
  );

  url: string;
  sidePanelOpened;
  routeData: any;

  options = {
    dark: false,
    boxed: false,
    collapsed: false,
    dir: 'ltr'
  };

  @ViewChild('sidemenu', { static: false })
  sidemenu;
  @ViewChild(PerfectScrollbarDirective, { static: false })
  directiveScroll: PerfectScrollbarDirective;

  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    private _element: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    public zone: NgZone,
    public loader: LoadingBarService,
    private titleService: Title,
    public viasService: ViasConnectionService
  ) {
    // this.mediaMatcher.addListener(mql =>
    //   zone.run(() => {
    //     this.mediaMatcher = mql;
    //   })
    // );
  }

  ngOnInit(): void {
    this.url = this.router.url;

    this._router = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        document.querySelector(
          '.app-inner > .mat-drawer-content > div'
        ).scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });
    this.runOnRouteChange();
  }

  ngOnDestroy(): void {
    this._router.unsubscribe();
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      this.sidePanelOpened = false;
    } else {
      this.updatePS();
    }

    this.route.children.forEach((route: ActivatedRoute) => {
      let activeRoute: ActivatedRoute = route;
      while (activeRoute.firstChild) {
        activeRoute = activeRoute.firstChild;
      }
      this.routeData = activeRoute.snapshot.data;
    });

    if (this.routeData.hasOwnProperty('heading')) {
      this.setTitle(this.routeData.heading);
    }
  }

  setTitle(newTitle: string): void {
    this.titleService.setTitle(
      newTitle + ' | Node - Angular Material 2 Admin Template'
    );
  }

  receiveMessage($event): void {
    this.options = $event;
    this.triggerWindowResize();
  }

  toggleSidenav(): void {
    this.sidemenu.toggle();
    this.triggerWindowResize();
  }

  isOver(): boolean {
    if (
      this.url === '/messages' ||
      this.url === '/calendar' ||
      this.url === '/media' ||
      this.url === '/maps/leaflet' ||
      this.url === '/taskboard'
    ) {
      return true;
    } else {
      return this.mediaMatcher.matches;
    }
  }

  updatePS(): void {
    if (!this.mediaMatcher.matches) {
      setTimeout(() => {
        this.directiveScroll.update();
      }, 350);
    }
  }

  triggerWindowResize(): void {
    if (typeof Event === 'function') {
      window.dispatchEvent(new Event('resize'));
    } else {
      const evt = window.document.createEvent('UIEvents');
      evt.initEvent('resize', true, false);
      window.dispatchEvent(evt);
    }
  }

  toggleFullscreen(): void {
    const elem = this._element.nativeElement.querySelector('.app-inner');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullScreen) {
      elem.webkitRequestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullScreen) {
      elem.msRequestFullScreen();
    }
  }
}

